import { FormItemOption } from './FormItemOption'
import { FormItemType } from './FormItemType'
import { SBModel } from './SBmodel'

export interface FormItem extends SBModel {
  question: string
  description?: string
  order?: number
  required?: boolean
  isCommentableByManager: boolean
  isAnswerableByManager: boolean

  //   Relations //
  type: FormItemType
  options?: FormItemOption[]
  associatedItems?: FormItem[]
}

export enum FormItemTypes {
  Title = 1,
  Input,
  TextArea,
  CheckboxGroup,
  Select,
  Rate,
  Spacer,
}
